export const brandLogos = {
  full: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/beyondigital-Logo.png',
  black: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/Beyond%20Digital%20black%20Logo.png',
  green: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/Beyond%20Digital%20Green%20Logo.png',
};
